import { inputFormReducerFactory } from 'state/secondaryMarket/shared/form/input/input.reducer';

import type { LimitOrderForm, LimitOrderInputForm } from './inputForm.model';
import { initialLimitOrderForm, initialLimitOrderFormMap } from './inputForm.model';

export const limitOrderInputFormReducer = inputFormReducerFactory<LimitOrderForm, LimitOrderInputForm, 'LIMIT_ORDER'>(
  'LIMIT_ORDER',
  initialLimitOrderFormMap,
  initialLimitOrderForm,
  'limitOrder',
);
